import { Component } from "@angular/core";
import { TagTableColumn } from '../custom-table-column/tag-table-column';
import { CustomTableValueComponent } from "./abstract-custom-table-value.component";

@Component({
    selector: 'tag-table-value',
    template: '<span [ngClass]="getClass()" [innerHTML]="getValue() | tagLocalize | loader:column.pipe:true:column.pipeArgument"></span>'
})
export class TagTableValueComponent extends CustomTableValueComponent<TagTableColumn> {
}